// FX-aware bid comparison wire contract. The web client uses these
// rates to score `price * rateRub[currency]` so cheapest-bid
// highlighting works across mixed currencies (USD/RUB/CNY). Comparison
// is client-side; backend only exposes the snapshot.

import { z } from 'zod';

/**
 * @aiPurpose CBR-RF FX snapshot wire shape returned by `GET /api/currency-rates`.
 * @aiInvariant `rates.RUB` is always `1` (identity row); USD and CNY carry
 *              per-unit RUB rate. `fetchedAt` is the MAX(fetched_at) over
 *              the three rows in storage.
 */
export const CurrencyRatesSchema = z
  .object({
    rates: z
      .object({
        USD: z.number().positive(),
        RUB: z.number().positive(),
        CNY: z.number().positive(),
      })
      .strict(),
    fetchedAt: z.string().datetime(),
  })
  .strict();
export type CurrencyRates = z.infer<typeof CurrencyRatesSchema>;
